import {
  AlertTriangle,
  CheckCircle2,
  MinusCircle,
  PieChart,
  Search,
  XCircle,
  type LucideIcon,
} from "lucide-react";

import type { StatusTone } from "./statusTone";

// One icon per tone (Master Prompt A25 (e)): Lucide, ISC licence
// (docs/references/third-party-licence-register.md). The icon is decoration beside the
// word that carries the meaning - never instead of it - so it is hidden from assistive
// technology and never focusable; the accessible names and texts of every panel stay as
// they were.

const ICONS: Record<StatusTone, LucideIcon> = {
  pass: CheckCircle2,
  warning: AlertTriangle,
  fail: XCircle,
  review: Search,
  "not-evaluated": MinusCircle,
  partial: PieChart,
};

type StatusIconProps = {
  tone: StatusTone;
  /** 16 in a pill, 20 in a banner heading or a card heading. */
  size: 16 | 20;
};

export function StatusIcon({ tone, size }: StatusIconProps) {
  const Icon = ICONS[tone];
  return (
    <Icon
      aria-hidden="true"
      focusable="false"
      data-status-icon={tone}
      size={size}
      strokeWidth={2.25}
    />
  );
}

export { ICONS };

export default StatusIcon;
